import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBaseDotsVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00001 8.66669C8.3682 8.66669 8.66668 8.36821 8.66668 8.00002C8.66668 7.63183 8.3682 7.33335 8.00001 7.33335C7.63182 7.33335 7.33334 7.63183 7.33334 8.00002C7.33334 8.36821 7.63182 8.66669 8.00001 8.66669Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00001 4.00002C8.3682 4.00002 8.66668 3.70154 8.66668 3.33335C8.66668 2.96516 8.3682 2.66669 8.00001 2.66669C7.63182 2.66669 7.33334 2.96516 7.33334 3.33335C7.33334 3.70154 7.63182 4.00002 8.00001 4.00002Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00001 13.3334C8.3682 13.3334 8.66668 13.0349 8.66668 12.6667C8.66668 12.2985 8.3682 12 8.00001 12C7.63182 12 7.33334 12.2985 7.33334 12.6667C7.33334 13.0349 7.63182 13.3334 8.00001 13.3334Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00001 8.66669C8.3682 8.66669 8.66668 8.36821 8.66668 8.00002C8.66668 7.63183 8.3682 7.33335 8.00001 7.33335C7.63182 7.33335 7.33334 7.63183 7.33334 8.00002C7.33334 8.36821 7.63182 8.66669 8.00001 8.66669Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00001 4.00002C8.3682 4.00002 8.66668 3.70154 8.66668 3.33335C8.66668 2.96516 8.3682 2.66669 8.00001 2.66669C7.63182 2.66669 7.33334 2.96516 7.33334 3.33335C7.33334 3.70154 7.63182 4.00002 8.00001 4.00002Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00001 13.3334C8.3682 13.3334 8.66668 13.0349 8.66668 12.6667C8.66668 12.2985 8.3682 12 8.00001 12C7.63182 12 7.33334 12.2985 7.33334 12.6667C7.33334 13.0349 7.63182 13.3334 8.00001 13.3334Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconBaseDotsVertical;
